import { connect } from 'react-redux';
import { StateType } from '../../../../state/state.types';

const mapState = ({ notifications }: StateType) => ({
  notifList: notifications.notifList,
});

export const Connect = connect(mapState);
